import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../redux/store';
import { Center, Spinner } from '@chakra-ui/react';

const PrivateRoute = ({ children }) => {
	const { isAuthenticated, isAdmin, loading } = useSelector((state: RootState) => ({
		isAuthenticated: state.auth.isAuthenticated,
		isAdmin: state.auth.isAdmin,
		loading: state.auth.loading,
	}));
	const location = useLocation();

	if (loading) {
		return (
			<Center h="100vh">
				<Spinner size="xl" />
			</Center>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (isAdmin) {
		return <Navigate to="/admin" replace />;
	}

	return children;
};

export default PrivateRoute;
